var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconStdio48Filled = function SvgIconStdio48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 9.3H14.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V14.6c0-2.92-2.38-5.3-5.3-5.3ZM23.04 26.2l-5.94 5.09-2.21-2.58 5.5-4.71-5.5-4.71 2.21-2.58 5.94 5.09c.64.55 1.01 1.35 1.01 2.2 0 .85-.37 1.65-1.01 2.2ZM33 31.29h-8v-3.4h8v3.4Z",
    fill: "current"
  })));
};
export default SvgIconStdio48Filled;